import { StoryblokComponent } from "@storyblok/react";
import { logger } from '@/lib/logger';

const BlogPageBulletproof = ({ content }: { content: any }) => {
  const {
    hero_blog_post,
    blog_details,
    blog_content,
    blog_conclusion,
    blog_author,
    blog_learn_more,
    banner_case_study,
    related_resources,
    quote_form,
    accreditations_big,
  } = content;

  // logger.log(`content` + JSON.stringify(content, null, 2));

  return (
    <>
      {Array.isArray(hero_blog_post) &&
        hero_blog_post.map((blok: any) => (
          <StoryblokComponent
            blok={blok}
            blog_details={blog_details}
            blog_author={blog_author}
            blog_content={blog_content}
            key={blok._uid || `${Math.random()}`}
          />
        ))}

      {Array.isArray(blog_details) &&
        blog_details.map((blok: any) => (
          <StoryblokComponent
            blok={blok}
            blog_content={blog_content}
            blog_author={blog_author}
            blog_conclusion={blog_conclusion}
            key={blok._uid || `${Math.random()}`}
          />
        ))}

      {Array.isArray(blog_content) &&
        blog_content.map((blok: any) => (
          <StoryblokComponent
            blok={blok}
            key={blok._uid || `${Math.random()}`}
          />
        ))}

      {Array.isArray(blog_conclusion) &&
        blog_conclusion.map((blok: any) => (
          <StoryblokComponent
            blok={blok}
            key={blok._uid || `${Math.random()}`}
          />
        ))}

      {Array.isArray(blog_author) &&
        blog_author.map((item: any) => {
          const content = item.content;
          return content ? (
            <StoryblokComponent
              blok={content}
              key={content._uid || `${Math.random()}`}
            />
          ) : null;
        })}

      {Array.isArray(blog_learn_more) &&
        blog_learn_more.map((blok: any) => (
          <StoryblokComponent
            blok={blok}
            key={blok._uid || `${Math.random()}`}
          />
        ))}

      {Array.isArray(banner_case_study) &&
        banner_case_study.map((blok: any) => (
          <StoryblokComponent
            blok={blok}
            key={blok._uid || `${Math.random()}`}
          />
        ))}

      {Array.isArray(related_resources) && (() => {
        if (!related_resources || related_resources.length === 0) {
          return null;
        }

        const blogItems = related_resources
          .filter((story: any) => {
            const isValid = story && story.content && typeof story.content === "object";
            if (!isValid) {
              logger.log("Invalid story content:", story?.uuid || story?._uid);
            }
            return isValid;
          })
          .map((story: any) => {
            const content = story.content;
            const metatags = content?.metatags || {};
            const blogDetail = Array.isArray(content?.blog_details) && content.blog_details.length > 0
              ? content.blog_details[0]
              : null;
            const blogAuthor = Array.isArray(content?.blog_author) ? content.blog_author[0] : {};

            const transformSlug = (fullSlug: string) => {
              const segments = fullSlug.split('/');
              return segments.length > 2 ? `/${segments.slice(2).join('/')}` : fullSlug;
            };

            return {
              _uid: story.uuid || `related-${Math.random()}`,
              component: "related_resources",
              title: story.name || "",
              thumb: blogDetail?.thumb?.filename || metatags?.og_image || "",
              topics: blogDetail?.topics || [],
              slug: transformSlug(story.full_slug || ""),
              author_name: blogAuthor?.name || "",
              author_photo: blogAuthor?.content?.image?.filename || "",
            };
          });

        if (blogItems.length === 0) {
          return null;
        }

        return (
          <section key="related-resources" className="container py-4 py-md-5">
            <h2 className="no-toc text-primary text-center mb-5">
              Related resources
            </h2>
            <div
              className="row g-4 justify-content-center row-cols-1 row-cols-md-2 row-cols-xl-4 gy-3 gx-md-3 gy-xl-0 gx-xl-4">
              {blogItems.map((blogItem: any) => (
                <StoryblokComponent
                  blok={blogItem}
                  key={blogItem._uid}
                />
              ))}
            </div>
          </section>
        );
      })()}

      {Array.isArray(quote_form) &&
        quote_form.map((blok: any) => (
          <StoryblokComponent
            blok={blok}
            key={blok._uid || `${Math.random()}`}
          />
        ))}

      {Array.isArray(accreditations_big) &&
        accreditations_big.map((item: any) => {
          const content = item.content;
          return content ? (
            <StoryblokComponent
              blok={content}
              key={content._uid || `${Math.random()}`}
            />
          ) : null;
        })}
    </>
  );
};

export default BlogPageBulletproof;